(function () {
	"use strict";

	angular.module("swurveys.maker")
		.factory("adminUpdateSwurveyModal", Handler)

	function Handler(ModalService, swurveyAdminService, swurveysStageConfig) {


		function show(swurvey, user) {

			return ModalService.showModal({
					templateUrl: "app/modals/swurvey/adminUpdate/adminUpdate.html",
					controller: ['$element', 'close', function ($element, close) {



						var modal = this;
                        modal.userIdPattern = 'us-east-1:\\w{8}-\\w{4}-\\w{4}-\\w{4}-\\w{12}';

						modal.user = user;
						modal.swurvey = swurvey;

						var userId = swurvey.OwnerId.substr(5);
						swurveyAdminService.getUser(userId, function(err, data) {
							console.log(err, data);
							swurvey.user = data;

						});

						modal.validateUser = function(userId) {
							resetLoaders();
							if(!userId) return;
							delete modal.newOwner;
							swurveyAdminService.getUser(userId, function(err, data) {
								resetLoaders();
								if(err)
								{
									modal.error = err;
									return;
								}
								modal.newOwner = data;

							});

						};

						modal.updateOwner = function(swurvey, newOwner) {

							resetLoaders();
							var newUserId = "user:" + newOwner.userId;
							modal.updating= true;
							swurveyAdminService.updateSwurvey(swurvey.id, { OwnerId : newUserId}, function(err, data)
							{
							    modal.updating= false;
								console.log(err, data);
								if(err){
									modal.error = err;
									return;
								}

								swurvey.user = modal.newOwner;
							});

						};

						modal.updateCreditPrice = function(swurvey) {
							resetLoaders();
							modal.updating= true;
							swurveyAdminService.updateSwurvey(swurvey.id, {creditPrice: swurvey.creditPrice}, function(err, data){
								modal.updating= false;
								if(err){
									return modal.error = err;
								}
							});
						}

						var resetLoaders = function() {
							modal.publishing = false;
							modal.addingCC = false;
							modal.purchasing = false;
							modal.updating= false;
							delete modal.error;
						};

						modal.close = function () {
							var shouldReload = swurvey.user == modal.newOwner;
							close(shouldReload, 500);
							$(".modal-backdrop").remove();
						};

					}],
					controllerAs: "modal"
				});
		}

		return {
			show: show
		};
	}
}());
